import React from "react";
import { Card, Dependentes } from "@components";
import { PlanoVinculadoEntidade } from "@entidades";
import { Col, Row } from "@intech/web-ui";
import { DateFix } from "@helpers";
import { SaldoAcumulado } from "./SaldoAcumulado";
import { UltimaContribuicao } from "./UltimaContribuicao";

interface IProps {
  plano: PlanoVinculadoEntidade
}

export const HomeAtivo: React.FC<IProps> = ({ plano }) => {
  return (
    <>
      {plano && <>
        <Row>
          <Col>
            <Card titulo={"Plano"}>
              {plano.DS_PLANO_PREVIDENCIAL}
            </Card>
          </Col>

          <Col>
            <Card titulo={"CNPJ do Plano"}>
              {plano.NUM_CNPJ}
            </Card>
          </Col>

          <Col>
            <Card titulo={"CNPB"}>
              {plano.NR_CODIGO_CNPB}
            </Card>
          </Col>

          <Col>
            <Card titulo={"Situação"}>
              {plano.DS_SIT_PLANO}
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <Card titulo={"Regime de Tributação"}>
              {plano.DS_OPCAO_TRIBUTACAO}
            </Card>
          </Col>

          <Col>
            <Card titulo={"Data de Inscrição"}>
              {DateFix(plano.DT_INSC_PLANO)}
            </Card>
          </Col>

          <Col>
            <Card titulo={"Tempo de Plano"}>{plano.DS_TEMPO_PLANO}</Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <UltimaContribuicao plano={plano} />
          </Col>
        </Row>

        <Row>
          <Col>
            <SaldoAcumulado plano={plano} />
          </Col>
        </Row>

        <Row>
          <Col>
            <Dependentes SqPlano={plano.SQ_PLANO_PREVIDENCIAL} />
          </Col>
        </Row>
      </>}
    </>
  );
};